import React from 'react'
import { Row } from 'antd'

const OptinInline = ({ id }) => {
  return (
    <Row style={{ justifyContent: 'center' }}>
      <div id={id} />
    </Row>
  )
}

export default OptinInline
